import React from 'react';
import { BsArrowUpRight, BsJava, BsLaravel, BsWind, BsReact } from 'react-icons/bs';
import {motion} from 'framer-motion'
import {fadeIn} from '../variants'






const programmingLanguages = [
  {
    name: 'JAVA',
    description: '<BsJava />',
  
  },
  {
    name: 'PHP/Laravel',
    description: 'Laravel is a powerful PHP framework used to build elegant and efficient web applications.',
    link: 'Learn More',
  },
  {
    name: 'REACTjs',
    description: 'HTML is the backbone of the web, used to structure and present content across the internet.',
    link: 'Learn More',
  },
  {
    name: 'JAVASCRIPT',
    description: 'HTML is the backbone of the web, used to structure and present content across the internet.',
    link: 'Learn More',
  },
];

const Services = () => {
  return (
    <section className='section' id='services'>
      <div className="container mx-auto">
        <div className='flex flex-col lg:flex-row'>
          <motion.div
            variants={fadeIn('right', 0.3)}
            initial='hidden'
            whileInView={'show'}
            viewport={{ once: false, amount: 0.3 }}
            className='flex-1 lg:bg-services lg:bg-buttom bg-no-repeat mix-blend-lighten mb-12 lg:mb-0'>
            <h2 className='h2 text-accent mb-6'>ABOUT ME</h2>
            <h3 className='h3 max-w-[455px] mb-16'>I am a dedicated Developer, proficient in various technologies, and committed to delivering excellent results.</h3>
            <button className='btn btn-sm'>Explore My Projects</button>
          </motion.div>
          <motion.div className='flex-1'
            variants={fadeIn('left', 0.5)}
            initial='hidden'
            whileInView={'show'}
            viewport={{ once: false, amount: 0.3 }}>
            <div>
            <h2 className='h2 text-accent mb-6'>SKILLS</h2>
              {programmingLanguages.map((language, index) => {
                const { name, description, link } = language;
                return (
                  
                  <div className='border-b border-white/20 h-[50px] mb-[38px] flex' key={index}>
                    
                    <div className='max-w-[476px]'>
                      <h4 className='text-[20px] tracking-wider font-primary font-semibold mb-6 '>{name}</h4>
                     
                    </div>
                  
                  </div>
                );
              })}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Services;




